import React from 'react';
import './styles.css';
import HorizontalLoader from '../HorizontalLoader';

const Card = ({ title, children, loading = false, actions = [] }) => {
  return (
    <div className="card">
      {title && (
        <div className="card__header">
          <h2 className="card__title">{title}</h2>
          <div className={'card__actions'}>
            {actions.length > 0 && actions.map((action, index) => (
              <button key={index} className="card__action" onClick={action.onClick}>
                {action.label}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="card__content">
        {loading && (
          <HorizontalLoader />
        )}
        {!loading && (
          <>{children}</>
        )}
      </div>
    </div>
  );
};

export default Card;
